const ACTION_PATH = 'app/desempenhoBiodiversidade'

export const CALL_LISTAR_DADOS_DESEMPENHO_BIODIVERSIDADE = `${ACTION_PATH}/CALL_LISTAR_DADOS_DESEMPENHO_BIODIVERSIDADE`

export const callListarDadosDesempenhoBiodiversidade = (payload) => ({
  type: CALL_LISTAR_DADOS_DESEMPENHO_BIODIVERSIDADE,
  payload,
})
